import React from 'react';
import './App.css';
import SudokuSolver from './SudokuSolver';

function App() {
  return (
    <div className="App">
      <SudokuSolver />
    </div>
  );
}

export default App;
